
import { createContext, useContext } from "react";

export type SupportedLanguage = 'en' | 'ko' | 'kn' | 'hi' | 'ta' | 'te';

interface LanguageContextType {
  language: string;
  setLanguage: (lang: string) => void;
}

export const normalizeLanguage = (lang?: string | null): SupportedLanguage => {
  if (!lang) return 'en';
  const supported: SupportedLanguage[] = ['en', 'ko', 'kn', 'hi', 'ta', 'te'];
  const code = lang.toLowerCase().split('-')[0];
  return supported.includes(code as SupportedLanguage) ? (code as SupportedLanguage) : 'en';
};

export const getBrowserLanguage = (): SupportedLanguage => {
  if (typeof navigator === 'undefined') return 'en';

  const browserLanguages = [
    ...(navigator.languages || []),
    navigator.language,
    (navigator as any).userLanguage,
    (navigator as any).browserLanguage
  ].filter(Boolean) as string[];

  const preferred = browserLanguages[0] || 'en';
  return normalizeLanguage(preferred);
};

export const getInitialLanguage = (): SupportedLanguage => {
  if (typeof window === 'undefined') return 'en';
  const storedLanguage = localStorage.getItem('appLang');
  return storedLanguage ? normalizeLanguage(storedLanguage) : getBrowserLanguage();
};

export const LanguageContext = createContext<LanguageContextType>({
  language: getInitialLanguage(),
  setLanguage: () => {},
});


export const useLanguage = () => useContext(LanguageContext);